import { useCallback } from 'react';

import { GenericHeader } from '../../../../components/banners/headers/GenericHeader';
import { useStores } from '../../../../stores/useStores';

import styles from './GamesHero.module.scss';

export function GamesHero({ fullHeightAnimation }: { fullHeightAnimation?: boolean }) {
  const { gamesSearchStore } = useStores();

  const closeSearch = useCallback(() => {
    if (!gamesSearchStore.isProviderSearch) {
      gamesSearchStore.closeSearch();
    }
  }, [gamesSearchStore]);

  return (
    <div className={styles.container} onClick={closeSearch}>
      <div className={styles.header}>
        <GenericHeader bannerClassName={styles.banner} fullHeightAnimation={fullHeightAnimation} />
      </div>
    </div>
  );
}
